/**
 * 🤖 AUTO-GENERATED API SCHEMA FILE - DO NOT EDIT DIRECTLY!
 *
 * This file is automatically generated from entity configuration files.
 * Any manual changes will be lost when the generator runs again.
 *
 * 🔄 DATA FLOW PIPELINE:
 * 1. Entity Config (config/entities/lookup_submission_statuses-entity-config.ts) → Single Source of Truth
 * 2. THIS FILE → TypeBox schemas for runtime validation + API types
 * 3. API Clients → Use these schemas for request/response validation
 * 4. React Hooks → Use these types for type-safe data fetching
 * 5. Components → Import types from this schema file
 *
 * 🛠️ TO MODIFY:
 * - Edit the entity config file: config/entities/lookup_submission_statuses-entity-config.ts
 * - Run: npm run schemas:gen (regenerates this file)
 *
 * 📋 ARCHITECTURE:
 * - Entity configs define field publicity, types, and validation rules
 * - TypeBox schemas provide runtime validation for API requests/responses
 * - Static types are derived from TypeBox schemas for compile-time safety
 * - Query options and response types standardize API interactions
 *
 * 🔗 RELATED FILES:
 * - config/entities/lookup_submission_statuses-entity-config.ts (source configuration)
 * - scripts/generate-api-clients.ts (this generator)
 * - client/api/generated_clients/generated-lookup_submission_statuses-api-client.ts (API client using these schemas)
 * - client/api/generated_hooks/lookup_submission_statuses.ts (React hooks using these types)
 *
 * 🔒 SECURITY: Only fields marked as 'public: true' in the config are included
 *
 * Source config: config/entities/lookup_submission_statuses-entity-config.ts
 * Public fields: 6/6 total fields
 */

import { Type, Static } from '@sinclair/typebox';


// TypeBox schemas for runtime validation (public fields only)
export const LookupSubmissionStatusesSchema = Type.Object({
  id: Type.String({ format: "uuid" }), // id field
  name: Type.Union([Type.String(), Type.Null()]), // name field
  code: Type.Union([Type.String(), Type.Null()]), // code field
  description: Type.Union([Type.String(), Type.Null()]), // description field
  created_at: Type.Union([Type.String({ format: "date-time" }), Type.Null()]), // created_at field
  updated_at: Type.String({ format: "date-time" }), // updated_at field
});

export const CreateLookupSubmissionStatusesSchema = Type.Object({
  name: Type.Optional(Type.Union([Type.String(), Type.Null()])), // name field
  code: Type.Optional(Type.Union([Type.String(), Type.Null()])), // code field
  description: Type.Optional(Type.Union([Type.String(), Type.Null()])), // description field
});

export const UpdateLookupSubmissionStatusesSchema = Type.Object({
  name: Type.Optional(Type.Union([Type.String(), Type.Null()])), // name field
  code: Type.Optional(Type.Union([Type.String(), Type.Null()])), // code field
  description: Type.Optional(Type.Union([Type.String(), Type.Null()])), // description field
});

// TypeScript types derived from TypeBox schemas (matching server-side pattern)
export type LookupSubmissionStatusesRow = Static<typeof LookupSubmissionStatusesSchema>;
export type LookupSubmissionStatusesInsert = Static<typeof CreateLookupSubmissionStatusesSchema>;
export type LookupSubmissionStatusesUpdate = Static<typeof UpdateLookupSubmissionStatusesSchema>;

// Legacy type aliases for backward compatibility
export type LookupSubmissionStatuses = LookupSubmissionStatusesRow;
export type CreateLookupSubmissionStatuses = LookupSubmissionStatusesInsert;
export type UpdateLookupSubmissionStatuses = Static<typeof UpdateLookupSubmissionStatusesSchema>;

// Field configuration metadata
export const LookupSubmissionStatusesFieldConfig = {
  filterable: ['id'] as const,
  sortable: ['created_at', 'updated_at'] as const,
  searchable: [] as const,
  required: ['id', 'updated_at'] as const,
  readonly: ['id', 'created_at', 'updated_at'] as const,
} as const;

// Query options interface for API operations
import type { UnifiedQueryOptions } from '../../config/search/global-search-config.js';

export interface LookupSubmissionStatusesQueryOptions extends UnifiedQueryOptions {}

// Response types for API operations
export interface LookupSubmissionStatusesResponse {
  data: LookupSubmissionStatuses[] | null;
  error: Error | null;
  count?: number;
}

export interface SingleLookupSubmissionStatusesResponse {
  data: LookupSubmissionStatuses | null;
  error: Error | null;
}
